<template>
  <div v-if="showDownload" class="d-wrap df-middle df-between" @click="downloadApp">
    <div class="df-middle" style="margin-left: 10vw;">
      <Pic src="home/google" width="24" height="24" />
      <t path="home_64" class="c-theme f-bold ml-8">Get WeTrade On Google play</t>
    </div>
    <Icon name="caret-right" sm  class="c-theme mr-16" />
  </div>
</template>

<script lang='ts'>
import { defineComponent, shallowRef } from 'vue'
import Pic from '@/components/Pic.vue'
import Icon from '@/components/Icon.vue'

export default defineComponent({
  name: 'TheDownloadEntry',
  components: {
    Pic,
    Icon,
  },
  setup () {
    const showDownload = shallowRef(false)

    const u = navigator.userAgent
    showDownload.value = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1

    const downloadApp = () => {
      window.location.href = 'market://details?id=com.wtmob.app'
    }

    return {
      showDownload,
      downloadApp,
    }
  },
})
</script>

<style scoped lang='scss'>
.d-wrap{
  width: 100%;
  height: 40px;
  background: var(--color-text);
  position: fixed;
  bottom: 64px;
  left: 0;
  right: 0;
}
</style>
